/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DatetimePicker from 'shared/ui/components/form-components/pickers/DatetimePicker.vue';

const __vue_script__ = {
    name: 'UpdateReminderBeforeTimeModal',

    components: {
        DatetimePicker,
    },

    props: {
        type: {
            type: String,
            required: true
        },

        config: {
            type: Object,
            required: true
        },

        saveHandler: {
            type: Function,
            required: false,
            default: () => {},
        },
    },

    data() {
        return {
            submitting: false,
            innerValue: {
                ...this.config,
            },
        };
    },

    computed: {
        timeSummary() {
            const humanized = this.$utils.time.humanizeTimeLeft(this.$utils.time.toSeconds(this.innerValue.time, 'hh:mm'), this.$i18n.locale);

            return this.$t('meetings.settings.communication.reminders.sending_all_summary_desc', [humanized]);
        },
    },

    methods: {
        async submit() {
            try {
                this.submitting = true;

                await this.saveHandler(this.innerValue);

                this.$emit('close');

            } catch (e) {
                console.error('[UpdateReminderBeforeTimeModal] saveHandler error.', e);
            } finally {
                this.submitting = false;
            }
        },
    },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "update-reminder modal-wrapper" }, [
    _c("div", { staticClass: "modal-header" }, [
      _c("span", {
        staticClass: "close",
        on: {
          click: function ($event) {
            return _vm.$emit("close")
          },
        },
      }),
      _c("h3", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "meetings.settings.communication.reminders.update_" +
                _vm.type +
                "_title"
            )
          )
        ),
      ]),
    ]),
    _c("div", { staticClass: "modal-body" }, [
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "meetings.settings.communication.reminders.update_" +
                _vm.type +
                "_body"
            )
          )
        ),
      ]),
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "sending-time" }, [
          _c("label", [
            _vm._v(
              _vm._s(
                _vm.$t("meetings.settings.communication.reminders.send_time")
              )
            ),
          ]),
          _c(
            "div",
            { staticClass: "time-select" },
            [
              _c("datetime-picker", {
                attrs: {
                  clearable: false,
                  label: _vm.$t(
                    "meetings.settings.communication.reminders.duration_before_label"
                  ),
                  "minute-step": 5,
                  format: "HH:mm",
                  "hour-options": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                  "minute-options": [
                    0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55,
                  ],
                  name: "time",
                  type: "time",
                  "value-type": "format",
                },
                model: {
                  value: _vm.innerValue.time,
                  callback: function ($$v) {
                    _vm.$set(_vm.innerValue, "time", $$v)
                  },
                  expression: "innerValue.time",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "time-summary" }, [
            _c("span", [_vm._v(_vm._s(_vm.timeSummary))]),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "footer",
        { staticClass: "actions", attrs: { slot: "bottom" }, slot: "bottom" },
        [
          _c(
            "button",
            {
              staticClass: "btn",
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("general.cancel")))]
          ),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "submit", disabled: _vm.submitting },
              on: { click: _vm.submit },
            },
            [_vm._v(_vm._s(_vm.$t("general.save")))]
          ),
        ]
      ),
    ]),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/meetings/reminders/UpdateReminderBeforeTimeModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__